import React from "react";

const InfoItem = ({ title, value }) => {
  return (
    <div className="info-item">
      <p className="info-title">{title}:</p>
      <p className="info-value">{value && value}</p>
    </div>
  );
};

export default InfoItem;
